var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_800",
    "data-name": "Raggruppa 800",
    transform: "translate(-53 -602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_799",
    "data-name": "Raggruppa 799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_798",
    "data-name": "Raggruppa 798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_797",
    "data-name": "Raggruppa 797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_796",
    "data-name": "Raggruppa 796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_771",
    "data-name": "Raggruppa 771",
    transform: "translate(0 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_770",
    "data-name": "Raggruppa 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_769",
    "data-name": "Raggruppa 769"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_65",
    "data-name": "Ellisse 65",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(53 848)",
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_66",
    "data-name": "Ellisse 66",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(67 862)",
    fill: "#fff"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotUpgrade);
export default __webpack_public_path__ + "static/media/dot-upgrade.c5512bb79e8832353e437bad8baecb64.svg";
export { ForwardRef as ReactComponent };